const styles = {
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  cta: {
    backgroundColor: '#20C1E7 !important',
  },
}

export default styles
